import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30b5588c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ai-notification__text" }


export default /*#__PURE__*/_defineComponent({
  __name: 'AiNotification',
  props: {
    notificationText: {},
    notificationType: {},
    notificationActive: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (_ctx.notificationActive)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([{
        'ai-notification--active': _ctx.notificationActive,
        'ai-notification--success': _ctx.notificationType === 'success',
        'ai-notification--pending': _ctx.notificationType === 'pending',
        'ai-notification--error': _ctx.notificationType === 'error',
      }, "ai-notification"])
          }, [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.notificationText), 1)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})